// src/api/checagens.ts
import http from './http';
import { Checagem, ChecagemImovel, ChecagemProgresso, ChecklistItem, EventoImovel, Tarefa, Campanha, StatusCanal, StatusTarefa, CanalChecklist } from '../models/checagens';

// 1) PATCH /checagens/:id
export const patchChecagemResponsavel = (id: number, responsavel_usuario_id: number) => {
  return http.patch<Checagem>(`/checagens/${id}`, { responsavel_usuario_id });
};

// 2) POST /checagens/:id/campanhas
export const postChecagemCampanha = (id: number, data: { canal: 'email'|'whatsapp'; nome?: string; observacao?: string }) => {
  return http.post<Campanha>(`/checagens/${id}/campanhas`, data);
};

// 3) GET /checagens/:id/progresso
export const getChecagemProgresso = (id: number) => {
  return http.get<ChecagemProgresso>(`/checagens/${id}/progresso`);
};

interface PaginatedChecagemImoveis {
  data: ChecagemImovel[];
  total: number;
}

// 4) GET /checagens/:id/imoveis
export const getChecagemImoveis = (id: number, params?: { status_workflow?: string, page?: number, pageSize?: number }) => {
  return http.get<PaginatedChecagemImoveis>(`/checagens/${id}/imoveis`, { params });
};

// GET /checagens/imoveis/:ciId
export const getChecagemImovel = (ciId: number) => {
  return http.get<ChecagemImovel>(`/checagem_imoveis/${ciId}`);
};

// 5) GET /checagens/imoveis/:ciId/checklist
export const getChecklist = (ciId: number) => {
  return http.get<ChecklistItem[]>(`/checagens/imoveis/${ciId}/checklist`);
};

// 6) PATCH /checagens/imoveis/:ciId/checklist/:canal
export const patchChecklist = (ciId: number, canal: CanalChecklist, data: { status_canal: StatusCanal; anotacoes?: string }) => {
  return http.patch<ChecklistItem>(`/checagens/imoveis/${ciId}/checklist/${canal}`, data);
};

// 7) POST /checagens/imoveis/:ciId/tarefas
export const postTarefa = (ciId: number, data: Partial<Tarefa>) => {
  return http.post<Tarefa>(`/checagens/imoveis/${ciId}/tarefas`, data);
};

// 8) PATCH /checagens/imoveis/tarefas/:tarefaId
export const patchTarefa = (tarefaId: number, data: { status?: StatusTarefa }) => {
  return http.patch<Tarefa>(`/checagens/imoveis/tarefas/${tarefaId}`, data);
};

// 9) GET /imoveis/:imovelId/eventos
export const getEventosImovel = (imovelId: number) => {
  return http.get<EventoImovel[]>(`/imoveis/${imovelId}/eventos`);
};

// 10) POST /checagens/imoveis/:ciId/captacao
export const postCaptacao = (ciId: number, data: { resultado: string }) => {
  return http.post(`/checagens/imoveis/${ciId}/captacao`, data);
};

// Endpoint hipotético para adicionar imóvel
export const postAddImovel = (checagemId: number, imovel_id: number) => {
  return http.post<ChecagemImovel>(`/checagem_imoveis`, { checagem_id: checagemId, imovel_id });
};

// GET /checagens/:id
export const getChecagem = (id: number) => {
  return http.get<Checagem>(`/checagens/${id}`);
};

// Adicional: GET para buscar todas as checagens
export const getChecagens = (params?: any) => {
    return http.get<Checagem[]>('/checagens', { params });
}

// POST /checagens
export const postChecagem = (data: { nome?: string; descricao: string; status: string }) => {
  return http.post<Checagem>('/checagens', data);
};

// GET /checagens/imoveis/:ciId/tarefas
export const getTarefas = (ciId: number) => {
  return http.get<Tarefa[]>(`/checagens/imoveis/${ciId}/tarefas`);
};

export const finalizarChecagem = (id: number) => {
  return http.put(`/checagens/${id}/finalizar`);
};